export enum ENUM_STATUS_TAREFA {
  'Atrasada' = 1,
  'No prazo' = 2,
  'Finalizada' = 3,
  'Finalizada c/ atraso' = 4
}
